'use strict';

/**
 * Selection helpers for the avoidances selector.
 *
 * Extracted from AvoidanceSelect.react.js (EAT-3929). The recompute block was
 * duplicated verbatim in toggleAvoidance and toggleExcludeFood; this is the
 * single source of truth. Behavior is preserved exactly, including the
 * unguarded `avoidResult.category_key` read (a missing avoidResult throws, as
 * it did before).
 */

/**
 * Recompute the `selected` flag on every option from the current selections.
 *
 * @param {Array}  avoidOptions  the flattened option list
 * @param {Object} avoidResults  uuid -> result (carries category_key / ancestor_keys)
 * @param {Array}  avoidances    selected category keys
 * @param {Array}  excludeFoods  selected food uuids
 * @returns {Array} a new options array with updated `selected` flags
 */
export function recomputeOptionSelection(avoidOptions, avoidResults, avoidances, excludeFoods) {
    return avoidOptions.map(option => {
        const isCategory = option.type === 'category';
        const avoidResult = avoidResults[option.value];
        const selected = isCategory
            ? avoidances.includes(avoidResult.category_key)
            : excludeFoods.includes(option.value) || avoidances.some(avoidance => (avoidResult.ancestor_keys || []).includes(avoidance));
        return { ...option, selected };
    });
}
